import { useEffect } from 'react';
import { appTitle } from '..';

export const useDocumentTitle = ({ title }: { title: string }) => {
  useEffect(() => {
    document.title = appTitle(title);
  });
};
